import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'sb-wrapper',
  templateUrl: './sb-wrapper.component.html',
  styleUrls: ['./sb-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbWrapperComponent {
  @Input()
  public title = '';

  @Input()
  public moduleName = '';

  @Input()
  public componentName = '';

  @Input()
  public serviceName = '';

  @Input()
  public decoratorName = '';

  @Input()
  public helperName = '';

  @Input()
  public pipeName = '';

  @Input()
  public directiveName = '';

  @Input()
  public version: string;
}
